import { IconButton } from 'native-base';

import { FavoriteIcon } from 'components/favorite-icon';
import { t } from 'state/intl/translations';
import noop from 'utils/noop';

export const CartEntryFabButton = ({
  cartEntryId,
  isFavorite,
  disabled,
  loading,
}: {
  cartEntryId: string;
  isFavorite?: boolean;
  disabled?: boolean;
  loading?: boolean;
}) => {
  const accessibilityLabel = isFavorite ? t('removeFavorite') : t('addFavorite');

  return (
    <IconButton
      variant="ghost"
      onPress={noop}
      testID="favorite-icon"
      disabled={disabled || loading}
      _web={{
        cursor: disabled ? 'not-allowed' : 'default',
      }}
      alignSelf="flex-start"
      position="absolute"
      right={0}
      top={-2}
      zIndex={1}
      icon={
        <FavoriteIcon isFavorite={isFavorite} disabled={disabled || loading} loading={loading} />
      }
      accessibilityLabel={accessibilityLabel}
      accessibilityState={{ checked: true }}
    />
  );
};
